import i18next from 'i18next';

// レスポンス情報
export type ResponceDataType = {
  ResponseCode: number;
  ErrorCode: number;
  ResponseMessage: string;
  ErrorMessage: string;
};

/**
 * バージョン情報レスポンス
 */
export type VersionInfoModel = {
  Version: string;
  responceData: ResponceDataType;
}

/**
 * バージョン情報を取得する処理 
 * @returns 
 */
export const GetVersionInfo = (): Promise<VersionInfoModel> => {
  console.debug(["GetVersionInfo()"]);
  return new Promise((resolve, reject) => {
    fetch('api/VersionManagement/VersionInfo')
      .then((res) => res.json())
      .then((result: VersionInfoModel) => {
        resolve(result);

      })
      .catch((error) => {
        console.log(["GetVersionInfo", error]);
        reject(error);
      });
  });
}